import { AlternativeContainers, ArrowsCircle, colors, TrashCanWheels } from 'component-library';
import { type Country } from '@sr/types';
import { getContainerImageFileName } from '@sr/utils';
import { env } from 'customer-portal-helpers/env';
import {
  ContainerImage,
  ContainerImageWrapper,
  ContainerSVGWrapper,
  MixedCargoSmallIconInnerWrapper,
  MixedCargoSmallIconWrapper,
  MixedContainerSVGWrapper,
} from './styles';
import { MixedCargoIcon } from './MixedCargoIcon';

type ArticleContainerImageProps = {
  containerId?: string;
  isOther?: boolean;
  isOnlyMixedCargo: boolean;
  showMixedCargoIcon?: boolean;
  width?: string;
  height?: string;
  country: Country;
};

export const ArticleContainerImage = ({
  containerId,
  isOnlyMixedCargo,
  showMixedCargoIcon,
  country,
  width,
  height,
  isOther,
}: ArticleContainerImageProps) => {
  if (isOther) {
    return (
      <ContainerSVGWrapper width={width} height={height} data-testid="container-img_arrow-circle">
        <ArrowsCircle color={colors.secondary.green} />
      </ContainerSVGWrapper>
    );
  }

  const fileName = getContainerImageFileName(containerId ?? '', country);

  if (!fileName && isOnlyMixedCargo) {
    return (
      <ContainerImageWrapper>
        <MixedContainerSVGWrapper
          width={width}
          height={height}
          data-testid="container-img_arrow-triangle"
        >
          <AlternativeContainers />
        </MixedContainerSVGWrapper>
        <MixedCargoSmallIconWrapper>
          <MixedCargoSmallIconInnerWrapper>
            <MixedCargoIcon />
          </MixedCargoSmallIconInnerWrapper>
        </MixedCargoSmallIconWrapper>
      </ContainerImageWrapper>
    );
  }

  const S3_ASSETS_URL = env('PORTAL_AWS_S3_ASSETS_URL');

  return (
    <ContainerImageWrapper>
      {containerId && fileName ? (
        <ContainerImage
          data-testid="container-img_photo"
          width={width}
          height={height}
          src={`${S3_ASSETS_URL}/container_images/${fileName}.png`}
          alt="Container image"
        />
      ) : (
        <ContainerSVGWrapper width={width} height={height} data-testid="container-img_placeholder">
          <TrashCanWheels color={colors.primary.grey} />
        </ContainerSVGWrapper>
      )}
      {showMixedCargoIcon && (
        <MixedCargoSmallIconWrapper>
          <MixedCargoSmallIconInnerWrapper>
            <MixedCargoIcon />
          </MixedCargoSmallIconInnerWrapper>
        </MixedCargoSmallIconWrapper>
      )}
    </ContainerImageWrapper>
  );
};
